import { PluginViewStateAdapter } from 'owa-editor';
import { ComposeViewState, getStore } from 'owa-mail-compose-store';

export default function createPluginViewStateAdapter<TPluginViewState>(
    originalViewState: ComposeViewState,
    getter: (viewState: ComposeViewState) => TPluginViewState
): PluginViewStateAdapter<TPluginViewState> {
    return () => {
        // Get the current compose view state using the initial view state's
        // compose ID, or else the initial view state itself if it has yet to
        // be placed in the store
        // Then retrieve the current plugin view state from the compose view state
        const composeStore = getStore();
        const viewState: ComposeViewState = composeStore.viewStates.get(
            originalViewState.composeId
        );
        return getter(viewState || originalViewState);
    };
}
